<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card-title class="pb-5">
              <!--              <v-btn @click="$router.push({name: 'admin.campaign'})" class="btn-back">-->
              <!--                <span class="flaticon2-reply icon-lg"></span>-->
              <!--                بازگشت-->
              <!--              </v-btn>-->
              <!--              <v-spacer/>-->
              <!--              {{ $t($route.meta.title) }}-->
              <!--              <v-spacer/>-->
              <v-btn
                @click="createCampaign"
                :loading="loading"
                class="submit-btn"
                v-status="'user_create'"
              >
                <span class="fa fa-bookmark icon-md ml-1"></span>
                ذخیره
              </v-btn>
              <!--                            <v-card elevation="2" outlined>-->
            </v-card-title>
            <v-card-text>
              <hr class="pb-3" />
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="عنوان"
                    outlined
                    dense
                    v-model="data.name"
                    counter
                    maxlength="30"
                    @keydown="isStringKey"
                    :error-messages="errors.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-select
                    v-model="data.user_type"
                    :items="user_types"
                    :error-messages="errors.service"
                    item-text="name"
                    item-value="value"
                    label="هدف"
                    outlined
                    dense
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-select
                    v-model="data.target_user"
                    :items="target_users"
                    :error-messages="errors.service"
                    item-text="name"
                    item-value="value"
                    label="جدید یا قدیمی"
                    outlined
                    dense
                  ></v-select>
                </v-flex>
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Provinces from "@/Provinces.json";

export default {
  name: "Create",
  data() {
    return {
      loading: false,
      errors: [],
      rules: {
        isInt: [(val) => !val || Number(val.toString()) || "فقظ عدد وارد کنید"],
      },
      data: {
        name: null,
        user_type: null,
        target_user: null,
      },
      user_types: [
        { name: "مشتری", value: "customers" },
        { name: "کاربر", value: "users" },
        { name: "هر ۲ مورد", value: "both", disabled: true },
      ],
      target_users: [
        { name: "قدیمی", value: "old" },
        { name: "جدید", value: "new" },
        { name: "هر ۲ مورد", value: "both" },
      ],
    };
  },
  mounted() {
    this.provinces = Provinces;
  },
  methods: {
    createCampaign() {
      this.$modal.showLoading();
      this.loading = true;
      this.requestApiPost("admin/campaign", { ...this.data })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.$router.push({ name: "admin.campaign" });
          this.$toast.success("کمپین با موفقیت ساخته شد.");
        })
        .catch(({ response }) => {
          this.loading = false;
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
  },
};
</script>

<style scoped></style>
